import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import check from '../../../assets/images/check_3x.png'
import disableCheck from '../../../assets/images/disableCheck.png'
import CustomInput from '../../CustomComponents/FormInputs';
import { useForm } from 'react-hook-form';
import HomeLayout from '../../Layout/HomeLayout';
import DynamicCard from '../../CustomComponents/DynamicHomeCard';
import { width } from '../../CustomComponents/Card/CardStyles';
import { addLineBreaks, displayErrorMessage, } from '../../../utils';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import upload from '../../../assets/images/Upload.png'
import uploadDisabled from '../../../assets/images/UploadDisabled.png'
import DeleteIcon from '../../../assets/images/DeleteIcon.png'
import closeIcon from '../../../assets/images/crossIcon.png'
import { CONTACT_US_URL } from '../../../network/URLConstants';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { LogoContainer } from '../../Layout/Footer/FooterStyles';
import Logo from '../../../assets/images/home_logo.png'
const UploadDocument = () => {
    const { register, } = useForm();
    const { t } = useTranslation();

    // Set page title
    useEffect(() => {
        document.title = t("page_title_document_upload");       
    }, [t]);
    const [isReview, setIsReview] = useState(true)
    const [isUploadDocuments, setIsUploadDocuments] = useState(false)
    const [files, setFiles] = useState([]);
    const [showModel, setShowModel] = useState(false);
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [progress, setProgress] = useState({});
    const [errors, setErrors] = useState({});
    const [completedFiles, setCompletedFiles] = useState({});
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const nameChanged = useSelector(state => state.nameChanged);
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[--modal-text-highlight] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)] lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";

    const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf', 'image/tiff'];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const validFiles = selectedFiles.filter(file => allowedTypes.includes(file.type));
        const invalidFiles = selectedFiles.filter(file => !allowedTypes.includes(file.type));

        const initialFiles = validFiles.map(file => ({
            name: file.name,
            progress: 0,
            error: ''
        }));

        setFiles((prev) => [...prev, ...initialFiles]);

        // Process valid files
        validFiles.forEach(file => {
            const formData = new FormData();
            formData.append('file', file);
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/upload', true);
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentLoaded = Math.round((e.loaded / e.total) * 100);
                    setProgress((prev) => ({ ...prev, [file.name]: percentLoaded }));
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    setErrors((prev) => ({ ...prev, [file.name]: '' }));
                } else {
                    setErrors((prev) => ({ ...prev, [file.name]: <span>{t("oops_exclamation")} <span>{t("File_Error")}</span> <span>{t("tryagain")}</span> </span> }));
                }
            };
            xhr.onerror = () => {
                setErrors((prev) => ({ ...prev, [file.name]: <span>{t("oops_exclamation")} <span>{t("File_Error")}</span> <span>{t("tryagain")}</span> </span> }));
            };

            xhr.send(formData);
        });
        invalidFiles.forEach(file => {
            setErrors((prev) => ({ ...prev, [file.name]: <span>{t("File_Error")}<span className='text-[#2965FB]'>{t("tryagain")}</span> </span> }));
            setProgress((prev) => ({ ...prev, [file.name]: 0 }));
            setFiles((prev) => [...prev, file]); // Add the file to the list to display in the UI
        });
        setIsUploadDocuments(validFiles.length > 0);
    };

    useEffect(() => {
        files.forEach((file) => {
            if (progress[file.name] >= 100 && !completedFiles[file.name]) {
                setTimeout(() => {
                    setCompletedFiles(prevState => ({
                        ...prevState,
                        [file.name]: true,
                    }));
                }, 1000);
            }
        });
    }, [files, progress, completedFiles]);

    const handleDeleteFile = (fileName) => {
        setFiles(files.filter((file) => file.name !== fileName));
        setProgress((prev) => {
            const { [fileName]: _, ...rest } = prev;
            return rest;
        });
    };

    const closeModel = () => {
        setShowModel(false)
    }

    const handleSubmit = async () => {
        if (nameChanged) {
            navigate('/cipUploadDocumentNameChange')
        }

        // Thanks
        showAlertModal(true, t("thanks"), t("Additional_Document_Success_Text"), t("Additional_Document_Success_SubText"), true, false, t('ok'), "", true, signUpkudzuPlusTrue ? require('../../../assets/kudzu-plus-images/illo-pending-dark.png') :
            require('../../../assets/images/file_pending.png'));
        dispatch({ type: 'NAME_CHANGED_IN_CIP', payload: { nameChanged: false } });
    }

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        navigate('/')

    }
    const handleBackToAccountVerification = () => {
        navigate('/cipAccountVerificationDeatails')
    }
    return (
        <>
            <div className="sm:px-[6%] md:py-10 sm:py-12 sm:mt-0 sm:ml-0 ml-9 mt-8  flex flex-wrap sm:flex-nowrap scroll-mt-0">
                <LogoContainer>
                    <img src={Logo} className="md:h-[39px] w-[97px] h-[29px] md:w-[130px] cursor-pointer" alt="Kudzu Logo" />
                </LogoContainer>
            </div>
            <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
                <div className=' sm:mt-0 sm:ml-0 ml-6 mt-8'>

                    {
                        files.length >= 2 ? (<div className="text-[#94C3E8] font-normal  ml-3 mt-3  lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]  sm:leading-[30px] leading-[31px] font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10 border-opacity-[50%]">
                            <p>{t("Welcome_back")}</p>
                            <p className='text-white'>{addLineBreaks(t("Little_More_Info"))}</p>
                        </div>) :
                            (<p className="text-white font-normal  ml-3 mt-3  lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]  sm:leading-[30px] leading-[31px] font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10 border-opacity-[50%]">{addLineBreaks(t("UploadVerification"))}</p>)
                    }
                </div>
                <div className='md:w-[110px] sm:w-[60px] w-[0px]'></div>
                <div className='flex flex-col lg:w-[860px] md:w-[700px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard header={false} CardRadius={true} cardWidth={width.allpolicies} HeaderRadius={true} backgroundColor={'pink'} isWhite={true} HeaderContent={false}>

                        <div class="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]  lg:text-[26px] md:text-[22px]  sm:text-[20px] text-[20px] leading-[36px] font-hanken-grotesk  sm:mx-0 mx-2">{t("Account_Verification")}</div>
                        <div class="lg:my-[2rem] md:my-[1.5rem] my-[1rem] ">
                            <div className='  flex sm:flex-row flex-col md:flex-row flex-coljustify-start item-start w-full gap-2'>
                                <div className=' flex flex-row gap-1'>
                                    <img src={isReview ? `${check}` : `${disableCheck}`} className='w-[14px] h-[14px] md:w-[20px] md:h-[20px] self-center' alt="" /><p className='font-[600] md:font-[300] sm:font-[400] md:text-[14px] sm:text-[12px] text-[12px] md:leading-[25px] sm:leading-[20px] leading-[20px] font-hanken-grotesk'>{t("Review_Info")}</p>
                                </div>
                                <div className='flex flex-row sm:mx-1 md:mx-1 mx-0'>
                                    <img src={isUploadDocuments && files.length > 1 ? `${check}` : `${disableCheck}`} className='w-[14px] h-[14px] md:w-[20px] md:h-[20px] self-center' alt="" /><p className='font-[600] mx-1 md:font-[300] sm:font-[400] md:text-[14px] sm:text-[12px] text-[12px] md:leading-[25px] sm:leading-[20px] leading-[20px] font-hanken-grotesk'>{t("Upload_Document")}</p>
                                </div>
                            </div>
                        </div>
                        <div className='border-t-[2.5px] border-[#A3CEBB] pb-10   sm:mx-0 mx-4'></div>

                        <div className='sm:w-[70%] md:w-[60%] w-[264px] sm:mx-0 mx-4'>
                            <div className='font-serif-pro  lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px]  md:leading-[25px] sm:leading-[18px] leading-[22px] font-normal text-[#262B3A]'>
                                <p>{files.length > 1 ? t("Additional_Document_Text") : t("Upload_Text1")}</p>
                            </div>
                        </div>
                        <div className="mt-8 md:pl-16 md:pr-[8rem]">
                            {files.map((file, index) => (
                                <div key={index} className="">
                                    {
                                        completedFiles[file.name] ? (
                                            <div className="flex items-center justify-between sm:p-5 p-5 sm:pb-6 sm:pt-6 border rounded mt-4">
                                                <span className='font-serif-pro text-[#262B3A] lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px]'>{file.name}</span>
                                                <button onClick={() => handleDeleteFile(file.name)} >
                                                    <img src={closeIcon} alt={t('delete')} className='w-5 h-5' />
                                                </button>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className='mb-4 p-2 border rounded-lg mt-4'>
                                                    <div className="flex items-center justify-between mb-2">
                                                        <span className="font-serif-pro text-[#262B3A] lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px]">{file.name}</span>
                                                        <button onClick={() => handleDeleteFile(file.name)}>
                                                            <span className=""><img src={DeleteIcon} alt={t('delete')} className='w-4 h-4 mr-3' /> </span>
                                                        </button>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <div className="w-full bg-gray-200 h-2 rounded-full">
                                                            <div className="bg-blue-500 h-2 rounded-full" style={{ width: `${progress[file.name] > 0 ? progress[file.name] : 0}%` }}
                                                            ></div>
                                                        </div>
                                                        <div className="font-serif-pro text-[#262B3A] lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px]">
                                                            {progress[file.name] === -1 ? (
                                                                <img src={disableCheck} alt="Start" className="ml-2 w-4 h-4" />
                                                            ) : <> {progress[file.name]}%</>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mb-4 mt-4'>
                                                    {errors[file.name] && (
                                                        displayErrorMessage(errors[file.name])
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            ))}

                            <div className="flex flex-col  mt-10 ">
                                <div className="flex flex-col">
                                    <div className="flex flex-row items-center justify-center p-6 sm:p-[2.5rem] border-2 border-dashed border-[#94C3E8] bg-gray-50 rounded-lg">
                                        <label htmlFor="uploadFile" className="cursor-pointer flex flex-col items-center">
                                            <img src={files.length >= 5 ? uploadDisabled : upload} alt="Upload Icon" className="h-5 w-5 mb-2" />
                                            <span className={`${files.length >= 5 ? 'text-[#94C3E8]' : 'text-[#2965FB]'} font-[600] md:font-[600] sm:font-[600]`}>
                                                {t("Upload")}
                                            </span>
                                        </label>
                                        <CustomInput type="file" name="uploadFile" label="Upload" register={register} onChange={handleFileChange} multiple disabled={files.length >= 5} />
                                    </div>
                                </div>
                                <div className='sm:w-[69%] w-[264px] sm:mx-0 mx-4 my-2'>
                                    <div className={`${files.length >= 5 ? 'text-[#b3b5ba]' : 'text-[#262B3A]'} font-serif-pro lg:text-[18px] md:text-[18px] sm:text-[16px] text-[14px] md:leading-[25px] sm:leading-[18px] leading-[22px] font-normal`}>
                                        <p>{t("Upload_Text2")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col pb-16 mt-28 sm:mb-0 mb-5'>
                            <div className='flex flex-row sm:justify-end justify-between sm:mx-0 '>
                                <button type="button" className='font-hanken-grotesklg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] leading-[18px] text-[#2965FB] font-bold' onClick={handleBackToAccountVerification}>{t("back")}</button>
                                {files.length ? (<button tabIndex={0} onClick={handleSubmit} className='font-hanken-grotesklg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] leading-[18px] text-[#2965FB] font-bold ml-14'>{t("submit")}</button>) : (<button tabIndex={0} className='font-hanken-grotesklg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] leading-[18px] text-[#94C3E8] font-bold ml-14'>{t("submit")}</button>)}
                            </div>
                        </div>

                    </DynamicCard>
                </div >
                <CustomAlertModel isOpen={showModel} onClose={closeModel} image={modelImage}
                    highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg} <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    btn2Exists={btn2Exists}
                    btn1Text={btn1Text}
                    btn2Text={btn2Text}
                    btn1TypeAcpt={btn1TypeAcpt}
                    onAcptBtnClick={onAcptBtnClick}
                />
            </div >
        </>
    )
}

export default UploadDocument;